import { createUuid } from '../tracking/createUuid';
import { getUtk } from './getUtk';
export const getUserExperimentIdentifier = () => {
  const experimentIdentifier = getUtk() || createUuid();
  return experimentIdentifier;
};